import {
  initialMaterialRequestForm,
  IssueMovement,
  MaterialRequestRecord,
  Movement,
} from '../types/MaterialRequest';
import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';

type MaterialRequestState = {
  data: MaterialRequestRecord | null;
  setData: (data: MaterialRequestRecord | null) => void;
  formData: MaterialRequestRecord;
  setFormData: (data: MaterialRequestRecord | undefined) => void;
  movements: Movement | null;
  setMovement: (data: Movement) => void;
  addMovement: (data: Movement) => void;
  editMovement: (id: string, data: Movement) => void;
  removeMovement: (id: string) => void;
  resetForm: () => void;
  issueMovement: IssueMovement | null;
  setIssueMovement: (issueMovement: IssueMovement) => void;
};

export const useMaterialRequestStore = create<MaterialRequestState>((set) => ({
  data: null,
  setData: (data) => set({ data }),
  formData: initialMaterialRequestForm,
  setFormData: (formData) => set({ formData }),
  movements: null,
  setMovement: (movements) => set({ movements }),
  addMovement: (data: Movement) => {
    const newData = { ...data, uuid: uuidv4() };
    set((state) => ({
      formData: {
        ...state.formData,
        movements: [...state.formData.movements, newData],
      },
    }));
  },
  editMovement: (uuid, newData) => {
    // Implementation of editOrderLine function
    set((state) => ({
      formData: {
        ...state.formData,
        movements: state.formData.movements.map((line) =>
          line.uuid === uuid ? { ...line, ...newData } : line,
        ),
      },
    }));
  },
  removeMovement: (uuid) => {
    // Implementation of removeOrderLine function
    set((state) => ({
      formData: {
        ...state.formData,
        movements: state.formData.movements.filter(
          (line) => line.uuid !== uuid,
        ),
      },
    }));
  },
  resetForm: () => set({ formData: initialMaterialRequestForm }),
  issueMovement: null,
  setIssueMovement: (issueMovement) => set({ issueMovement }),
}));
